export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11471.c4a17eb9.jpg";